// разбирает ссылку вида [текст ссылки](ссылка)
export default (link: string) => {
  const matchedLink = link.match(/\[(.*)\]\((.*)\)/) || [];
  return {
    textOfLink: matchedLink[1] || matchedLink[2] || '',
    link: matchedLink[2] || '',
  };
};
